import * as React from "react";
import "./reconciliationModal.scss"
import CurrencyHelper from "../../../../../helper/CurrencyHelper";
import {Option} from "ts-option";
import DataGrid from "../../../../../hiberUiKit/src/organisms/DataGrid/DataGrid";
import BillPaymentSummary from "../../../../../model/bill/BillPaymentSummary";
import classNames = require("classnames");

interface IProps {
	billPaymentSummaries: BillPaymentSummary[];
	selectedSummaryId: Option<string>;
	onSummarySelect: (summary: BillPaymentSummary) => void;
}

export const BillPaymentSummariesTable: React.SFC<IProps> = (props) => {
	return (
		<div className="c-reconciliation-modal_matched-invoices-table-container">
			<div className="c-reconciliation-modal_matched-invoices-table-container_internal-container">
				<DataGrid>
					<thead>
					<tr className="c-reconciliation-modal_matched-invoices-table-container_table-header-row">
						<th>REF #</th>
						<th>PARTNER NAME</th>
						<th>AMOUNT</th>
					</tr>
					</thead>
					<tbody>
					{props.billPaymentSummaries.length === 0 && renderTableNoDataInfo}
					{props.billPaymentSummaries.map((summary, index) => {
						const classFromProps = classNames({
							"c-reconciliation-modal_matched-invoices-table-container_row": true,
							"selected": summary.id === props.selectedSummaryId.orNull
						});
						return (
							<tr className={classFromProps} onClick={() => props.onSummarySelect(summary)} key={index}>
								<td>{summary.referenceNumber}</td>
								<td>{summary.partnerName}</td>
								<td>{CurrencyHelper.toCurrency(summary.paymentAmount)}</td>
							</tr>
						);
					})}
					</tbody>
				</DataGrid>
			</div>
		</div>
	);
};

const renderTableNoDataInfo =
	<tr className="c-reconciliation-modal_matched-invoices-table-container_no-data-row">
		<td colSpan={4}>
			<div className="c-reconciliation-modal_matched-invoices-table-container_no-data-row_content">
				Matched bill(s) will be shown here.
			</div>
		</td>
	</tr>;
